<template>
    <!-- SHARE -->
    <div
      v-if="
        serviceReport &&
        serviceReport.quotes.length &&
        serviceReport.quotes[0].share_method
      "
    >
      <v-alert icon="mdi-share">
        <h4 class="mt-0 mb-1">
          {{ $t('quote.share.title') }}
        </h4>

        <div :class="!$vuetify.breakpoint.mobile ? 'd-flex' : 'd-block'">
          <div class="mr-5">
            <p class="caption mb-0 grey--text">
              {{ $t('quote.share.label.sendTo') }}
            </p>
            <p class="mb-0 body-2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="d-block body-2 mw-150 text-truncate"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ shareType(serviceReport.quotes[0].share_method, serviceReport.quotes[0].sent_to) }}
                  </span>
                </template>
                <span class="body-2">
                  {{ shareType(serviceReport.quotes[0].share_method, serviceReport.quotes[0].sent_to) }}
                </span>
              </v-tooltip>
            </p>
          </div>
          <div class="mr-5">
            <p class="caption mb-0 grey--text">
              {{ $t('quote.share.label.shared') }}
            </p>
            <p class="mb-0 body-2">
              {{ sharedAt ? formatDate(sharedAt) : '---' }}
            </p>
          </div>
          <div>
            <p class="caption mb-0 grey--text">
              {{ $t('quote.share.label.viewed') }}
            </p>
            <p class="mb-0 body-2">
              {{ viewedAt ? formatDate(viewedAt) : '---' }}
            </p>
          </div>
        </div>
      </v-alert>
    </div>
    <!-- /SHARE -->
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogDate, catalogPhone } from '@/util/catalog'

export default {
  name: 'AppointmentQuoteShareInfo',

  computed: {
    ...mapGetters(['serviceReport']),

    viewedAt() {
      return this.serviceReport.quotes[0].viewed_at
    },

    sharedAt() {
      return this.serviceReport.quotes[0].shared_at
    }
  },

  methods: {
    shareType(type, value) {
      switch(type) {
        case 'PHONE':
          return this.formatPhone(value)
        default:
          return value
      }
    }
  },

  data() {
    return {
      formatDate: catalogDate,
      formatPhone: catalogPhone
    }
  }
}
</script>
